export default {
    title: 'Leki',
    subtitle: 'Dziś wzięte {taken} z {total}',
    newMedication: 'Nowy lek',
    today: {
        title: 'Dziś',
        nothing: 'Na dziś nie ma żadnych dawek.',
        allDone: 'Wszystkie dzisiejsze dawki odhaczone.',
    },
    list: {
        title: 'Twoje leki',
        until: 'do {date}',
        from: 'od {date}',
        finished: 'kuracja zakończona',
        daysLeft: 'zapas na {n} dzień | zapas na {n} dni',
        noStock: 'zapas nieliczony',
        rate: '{n}% wziętych · 30 dni',
    },
    empty: {
        title: 'Jeszcze bez leków',
        text: 'Dodaj lek albo suplement z godzinami dawek — każdego dnia odhaczysz, co wzięte, a przy zapasie zobaczysz, kiedy dokupić.',
    },
    archive: {
        title: 'Archiwum',
        empty: 'Nic tu nie ma.',
        offPlan: 'poza planem',
    },
    pick: {
        title: 'Wybierz lek',
        text: 'Zobaczysz jego zapas, skuteczność i ostatnie dni — i zmienisz, co trzeba.',
    },
    toolbar: {
        back: 'Wróć do listy',
        archived: 'W archiwum',
        archive: 'Do archiwum',
        restore: 'Przywróć',
        remove: 'Usuń lek',
    },
    toast: {
        saved: 'Zapisane.',
        taken: 'Wzięte: {name}.',
        skipped: 'Pominięte: {name}.',
        undone: 'Cofnięte.',
        restocked: 'Zapas: {n} szt.',
        archived: '„{name}" w archiwum.',
        restored: '„{name}" znów na liście.',
        removed: 'Usunięto „{name}".',
    },
    // stan dawki
    states: {
        pending: 'czeka',
        due: 'teraz',
        taken: 'wzięte {time}',
        takenPlain: 'wzięte',
        skipped: 'pominięte',
        missed: 'spóźnione',
        missedPast: 'niewzięte',
    },
    dose: {
        take: 'Wzięte',
        skip: 'Pomiń',
        undo: 'Cofnij',
        offPlan: 'poza planem',
    },
    // harmonogram słowami: „8:00 i 20:00, codziennie"
    schedule: {
        daily: 'Codziennie',
        weekdays: 'W wybrane dni',
        every_n_days: 'Co kilka dni',
        dailyLabel: 'codziennie',
        everyLabel: 'co {n} dni',
        joined: '{times}, {days}',
    },
    numbers: {
        title: 'Jak idzie',
        stock: 'Zapas',
        stockValue: '{n} szt.',
        daysLeft: 'na {n} dzień | na {n} dni',
        noStock: 'nie liczysz',
        rate: 'Skuteczność · 30 dni',
        rateOf: '{taken} z {planned} dawek',
        perDay: 'dawek dziennie: {n}',
    },
    restock: {
        title: 'Dokupiłem',
        placeholder: 'ile szt.',
        add: '+ dokupiłem',
        set: 'Ustaw zapas',
    },
    edit: {
        title: 'Ustawienia leku',
    },
    history: {
        title: 'Ostatnie dni',
        empty: 'Jeszcze nic.',
        extra: 'poza planem {time}',
    },
    form: {
        name: 'Nazwa',
        namePlaceholder: 'np. Apap, Witamina D',
        dose: 'Dawka',
        dosePlaceholder: 'np. 1 tabletka 500 mg',
        times: 'Godziny',
        addTime: 'Dodaj godzinę',
        removeTime: 'Usuń godzinę {time}',
        days: 'Dni',
        every: 'Co ile dni',
        everySuffix: 'dni',
        course: 'Kuracja',
        noEnd: 'Bez końca',
        until: 'Do dnia',
        startOn: 'Od',
        endOn: 'Do',
        stock: 'Zapas',
        noStock: 'Nie liczę',
        countStock: 'Liczę sztuki',
        stockPieces: 'sztuk teraz',
        perDose: 'na dawkę',
        perDoseHint: 'Ile sztuk zużywa jedna dawka — tyle ubywa z zapasu po „Wzięte".',
        notes: 'Notatki',
        notesPlaceholder: 'np. po jedzeniu',
        save: 'Zapisz',
        add: 'Dodaj lek',
        cancel: 'Anuluj',
        needTime: 'Dodaj co najmniej jedną godzinę.',
    },
    planner: {
        title: 'Leki dnia',
        open: 'Otwórz Leki',
    },
    help: {
        today: {
            title: 'Dziś',
            text: 'Dawki na dziś po godzinie. „Wzięte" odhacza dawkę (i zmniejsza zapas), „Pomiń" zapisuje, że świadomie jej nie bierzesz.',
            more: 'Kolor mówi o stanie: szary — czeka, niebieski — teraz (od godziny do 2 godzin po niej), zielony — wzięte z godziną, jasny — pominięte, pomarańczowy — spóźnione. Pomyłkę cofniesz przyciskiem „Cofnij".',
        },
        list: {
            title: 'Twoje leki',
            text: 'Każdy lek z harmonogramem słowami, końcem kuracji, zapasem na ile dni i skutecznością z ostatnich 30 dni.',
            more: 'Zapas robi się pomarańczowy, gdy starczy na mniej niż tydzień — wtedy przyjdzie też przypomnienie o wykupieniu.',
        },
        add: {
            title: 'Nowy lek',
            text: 'Nazwa, dawka słowami, godziny, dni i — jeśli chcesz — kuracja od–do i zapas sztuk.',
            more: 'Asystent też odhaczy dawkę: „wziąłem leki" albo „wziąłem apap".',
        },
        stock: {
            title: 'Zapas',
            text: 'Ile sztuk zostało. Każda wzięta dawka zabiera tyle sztuk, ile ustawisz „na dawkę"; cofnięta oddaje.',
            more: 'Po zakupie kliknij „+ dokupiłem" i wpisz, ile sztuk doszło.',
        },
        history: {
            title: 'Ostatnie dni',
            text: 'Dawki z ostatnich dwóch tygodni z tym, co się z nimi stało, i przyjęcia poza planem.',
            more: 'Skuteczność liczy tylko dawki, których pora już minęła.',
        },
        schedule: {
            title: 'Godziny i dni',
            text: 'Godziny dawek w ciągu dnia oraz dni: codziennie, w wybrane dni tygodnia albo co kilka dni (licząc od początku).',
            more: 'Kuracja z końcem znika z „Dziś" po ostatnim dniu.',
        },
    },
    tour: {
        welcome: {
            title: 'Witaj w Lekach',
            description: 'Leki i suplementy według godzin: odhaczasz każdą dawkę, a zapas liczy się sam.',
        },
        medication: {
            title: 'Lek',
            description: 'Po kliknięciu leku: zapas z „+ dokupiłem", skuteczność, ostatnie dni i ustawienia. Tam też archiwum i usuwanie.',
        },
        end: {
            title: 'To wszystko',
            description: 'Przewodnik wróci zawsze pod przyciskiem „Pomoc" — tam są też Pierwsze kroki. Dawki dnia widzisz też w Planerze i w Teraz u asystenta.',
        },
    },
    firstSteps: {
        medication: {
            title: 'Pierwszy lek',
            action: 'Dodaj lek',
            what: 'Kliknij „Nowy lek", wpisz nazwę, dawkę i godziny.',
            why: 'Dawki pokażą się w „Dziś", w Planerze i w przypomnieniach.',
        },
        taken: {
            title: 'Pierwsza dawka',
            action: 'Odhacz',
            what: 'Kliknij „Wzięte" przy dzisiejszej dawce.',
            why: 'Widzisz, co już wzięte, a skuteczność rośnie.',
        },
        stock: {
            title: 'Zapas',
            action: 'Wpisz zapas',
            what: 'Przy leku wpisz, ile sztuk zostało w opakowaniu.',
            why: 'Dowiesz się na tydzień wcześniej, że trzeba dokupić.',
        },
    },
};
